import { FC, useEffect, useState } from "react";
import { ListGroup, ListGroupProps } from "react-bootstrap";
import FlexBox from "./flex-box";
import { PiX } from "react-icons/pi";
import LoadingBox from "./loading-box";

interface SimpleListProps extends ListGroupProps {
  selectedItemIndex?: number;
  disabledItems?: string[];
  highlightedItems?: string[];
  items: string[];
  isShowDeleteIcon?: boolean;
  showLoadingForIndex?: number;
  onItemClick?: (itemIndex: number) => void;
  onItemDeleted?: (itemIndex: number) => void;
}

const SimpleList: FC<SimpleListProps> = ({
  selectedItemIndex,
  disabledItems,
  highlightedItems,
  items,
  isShowDeleteIcon = false,
  showLoadingForIndex = -1,
  onItemDeleted,
  onItemClick,
  ...props
}) => {
  const [selectedIndex, setSelectedIndex] = useState(selectedItemIndex);

  useEffect(() => {
    setSelectedIndex(selectedItemIndex);
  }, [selectedItemIndex]);

  return (
    <ListGroup as="ul" {...props}>
      {(items ?? []).map((item, index) => (
        <ListGroup.Item
          as="li"
          key={index}
          onClick={() => onItemClick?.(index)}
          active={selectedIndex === index}
          className={`cursor-pointer w-full hover-primary ${
            disabledItems?.includes(item) && "text-grey"
          } ${highlightedItems?.includes(item) && "text-blue fw-bold"}`}
          disabled={disabledItems?.includes(item)}
        >
          <FlexBox>
            {item}
            <>
              {showLoadingForIndex === index ? (
                <LoadingBox color="secondary" isNoFlex />
              ) : (
                <>
                  {isShowDeleteIcon && (
                    <PiX onClick={() => onItemDeleted?.(index)} />
                  )}
                </>
              )}
            </>
          </FlexBox>
        </ListGroup.Item>
      ))}
    </ListGroup>
  );
};

export default SimpleList;
